import { useConversationsContext } from "../context/ConversationsContext";

/** @deprecated import path kept for existing pages — backed by ConversationsProvider. */
export function useConversations() {
  return useConversationsContext();
}
